/* eslint-disable import/prefer-default-export */
import React from "react";
import { Box, Button } from "@mui/material";

import { OpdSettings } from "./OpdSettings";
import Panel from "../../../../components/Panel";
import SettingsButton from "../../../../components/SettingsButton/SettingsButton";

interface Props {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  renderSettingButton?: boolean;
}

export const OpdSettingsPanel = ({
  open,
  onOpenChange,
  renderSettingButton = true
}: Props): React.ReactNode => {
  const [internalOpen, setInternalOpen] = React.useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);

  const isControlled = typeof open === "boolean";
  const actualOpen = isControlled ? open : internalOpen;

  const setOpen = (value: boolean): void => {
    if (isControlled) {
      onOpenChange?.(value);
    } else {
      setInternalOpen(value);
    }
  };

  return (
    <>
      {renderSettingButton && <SettingsButton onClick={() => setOpen(!actualOpen)} />}

      {actualOpen && (
        <Panel
          onClose={() => setOpen(false)}
          title="OPD Settings"
          wrapperStyle={{ maxWidth: "600px", width: "600px" }}
          contentStyle={{ height: "calc(100vh - 100px)", py: 0 }}
          footer={
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 2,
                width: "100%"
              }}
            >
              <Button onClick={() => setOpen(false)}>Cancel</Button>
              <Button
                variant="contained"
                onClick={() => {
                  setShowConfirmDialog(true);
                }}
              >
                Save
              </Button>
            </Box>
          }
        >
          <OpdSettings
            showConfirmDialog={showConfirmDialog}
            setShowConfirmDialog={setShowConfirmDialog}
          />
        </Panel>
      )}
    </>
  );
};
